import { render, staticRenderFns } from "./EditorsGroup.vue?vue&type=template&id=18bc8164&"
import script from "./EditorsGroup.vue?vue&type=script&lang=js&"
export * from "./EditorsGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports